import coronaCrashBook from 'assets/images/coronaCrashBook.png';
import coronaCrashBookOverview from 'assets/images/booksOverview/coronaCrashBook.png';

import {
  REGISTER,
  ONLY_PURCHASE,
  LOGIN,
  ADDRESS,
  PAYMENT,
  PREMIUM_OFFER,
  THANKS,
  PASSWORD,
  FIRST_NAME,
  LAST_NAME,
  ZIP_CODE,
  CITY,
  COUNTRY,
  EMAIL,
  MARKET_VOUCHER,
  PROCESSION_VOUCHER,
  PRINTED_BOOK,
  SMART_BOOKS,
} from '../const';

const coronaCrash = {
  book: {
    id: 'corona-crash',
    format: SMART_BOOKS,
    title: 'History rhymes – also on the stock market',
    subtitle: 'The Corona-Crash and its teaching',
    price: [21, 34],
    introductions: ['Introduction', 'About the book'],
    image: coronaCrashBook,
    overviewImg: coronaCrashBookOverview,
  },
  bookIds: [1, 3, 4],
  getDefaultOption: ({ isPremium, isBasic, voucher }) =>
    (isBasic && 1) ||
    (!isPremium && voucher === MARKET_VOUCHER && 2) ||
    (!isPremium && voucher === PROCESSION_VOUCHER && 3) ||
    (!isPremium && 2) ||
    0,
  getDefaultStrictMode: ({ isPremium, isBasic, voucher }) =>
    Boolean(isBasic || isPremium || voucher === MARKET_VOUCHER || voucher === PROCESSION_VOUCHER),
  orderOptions: [PRINTED_BOOK],
  purchases: [
    {
      id: 1,
      name: 'Fintool Premium Subscriber',
      tasks: {
        [LOGIN]: () => ({
          banner: {
            title: 'Fintool Premium Subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [21, 34],
            propositions: ['Printed book corona', 'Access to the digital video book'],
          },
          form: {
            showSubscribeDescription: false,
            inputs: [EMAIL, PASSWORD],
            submitButton: 'Login',
            showAdb: false,
          },
          nextStep: 1,
        }),
        [ADDRESS]: () => ({
          banner: {
            title: 'Fintool Premium Subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [21, 34],
            propositions: ['Printed book corona', 'Access to the digital video book'],
          },
          form: {
            showSubscribeDescription: false,
            inputs: [ADDRESS, ZIP_CODE, CITY, COUNTRY],
            submitButton: 'Continue',
            showAdb: false,
          },
          navigation: '1/2',
          nextStep: 2,
        }),
        [PAYMENT]: () => ({
          banner: {
            title: 'Fintool Premium Subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [21, 34],
            propositions: ['Printed book corona', 'Access to the digital video book'],
          },
          form: { withPromoCode: false },
          navigation: '2/2',
          prevStep: 1,
          nextStep: 3,
          shouldSignUp: false,
          subscribeId: null,
          productId: 1,
        }),
        [THANKS]: () => ({
          form: {
            title: 'Your order is on its way',
            description:
              'Thank you for your order. The book is on its way to you. Take advantage of the Fintool Premium offer and expand your money knowledge in one of our courses.',
            button: { name: 'To the Fintool Academy', url: '/akademie' },
          },
        }),
      },
    },
    {
      id: 2,
      name: 'Fintool Basic subscriber',
      tasks: {
        [LOGIN]: () => ({
          banner: {
            title: 'Fintool Basic subscriber',
            price: 'PriceCHF',
            priceValues: [34],
            propositions: ['Printed book corona'],
          },
          form: {
            showSubscribeDescription: false,
            inputs: [EMAIL, PASSWORD],
            submitButton: 'Login',
            showAdb: false,
          },
          nextStep: 1,
        }),
        [ADDRESS]: () => ({
          banner: {
            title: 'Fintool Basic subscriber',
            price: 'PriceCHF',
            priceValues: [34],
            propositions: ['Printed book corona'],
          },
          form: {
            showSubscribeDescription: false,
            inputs: [ADDRESS, ZIP_CODE, CITY, COUNTRY],
            submitButton: 'Continue',
            showAdb: false,
          },
          navigation: '1/3',
          nextStep: 2,
        }),
        [PREMIUM_OFFER]: () => ({
          banner: {
            title: 'Fintool Basic subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [21, 34],
            propositions: [
              'Printed book corona',
              'Unlimited access to video library',
              'Access to the entire course offering',
              'Unlimited access to the forums',
              'Knowledge reviews',
              'No advertising breaks',
            ],
          },
          form: {
            title: 'Switch to Fintool-Premium now',
            priceDescription: 'With Fintool-Premium you get the «SmartBook» at a preferential price',
            priceValues: [21, 34, 10],
            yesButton: 'Yes, buy Premium',
            noButton: 'Continue without Premium',
          },
          navigation: '2/3',
          prevStep: 1,
          nextStep: 3,
        }),
        [PAYMENT]: (wishPremium) => ({
          banner: {
            title: wishPremium ? 'Fintool Premium Subscriber' : 'Fintool Basic subscriber',
            price: wishPremium ? 'PriceCHF/insteadCHF' : 'PriceCHF',
            priceValues: wishPremium ? [21, 34] : [34],
            propositions: wishPremium
              ? [
                  'Printed book corona',
                  'Unlimited access to video library',
                  'Access to the entire course offering',
                  'Unlimited access to the forums',
                  'Knowledge reviews',
                  'No advertising breaks',
                ]
              : ['Printed book corona'],
          },
          form: { withPromoCode: false },
          navigation: '3/3',
          prevStep: 2,
          nextStep: 4,
          shouldSignUp: false,
          subscribeId: wishPremium ? 5 : null,
          productId: wishPremium ? 1 : 3,
        }),
        [THANKS]: () => ({
          form: {
            title: 'Your order is on its way',
            description:
              'Thank you for your order. The book is on its way to you. Take advantage of the Fintool Premium offer and expand your money knowledge in one of our courses.',
            button: { name: 'To the Fintool Academy', url: '/akademie' },
          },
        }),
      },
    },
    {
      id: 3,
      name: 'No subscription',
      tasks: {
        [ONLY_PURCHASE]: () => ({
          banner: {
            title: 'No subscription',
            price: 'PriceCHF',
            priceValues: [34],
            propositions: ['Printed book corona'],
          },
          form: {
            showSubscribeDescription: false,
            inputs: [FIRST_NAME, LAST_NAME, ADDRESS, ZIP_CODE, CITY, COUNTRY, EMAIL],
            submitButton: 'Continue',
            showAdb: false,
          },
          navigation: '1/3',
          nextStep: 1,
        }),
        [PREMIUM_OFFER]: () => ({
          banner: {
            title: 'No subscription',
            price: 'PriceCHF/insteadCHF',
            priceValues: [21, 34],
            propositions: [
              'Printed book corona',
              'Unlimited access to video library',
              'Access to the entire course offering',
              'Unlimited access to the forums',
              'Knowledge reviews',
              'No advertising breaks',
            ],
          },
          form: {
            title: 'Switch to Fintool-Premium now',
            priceDescription: 'With Fintool-Premium you get the «SmartBook» at a preferential price',
            priceValues: [21, 34, 10],
            yesButton: 'Yes, buy Premium',
            noButton: 'Continue without Premium',
          },
          navigation: '2/3',
          prevStep: 0,
          nextStep: [2, 3],
        }),
        [PASSWORD]: () => ({
          banner: {
            title: 'Fintool Premium Subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [21, 34],
            propositions: ['Printed book corona', 'Fintool-Premium'],
          },
          form: {
            title: 'Set a password for your Fintool account',
            showSubscribeDescription: false,
            inputs: [PASSWORD],
            submitButton: 'Register',
            showAdb: true,
          },
          navigation: '3/4',
          prevStep: 1,
          nextStep: 3,
        }),
        [PAYMENT]: (wishPremium) => ({
          banner: {
            title: wishPremium ? 'Fintool Premium Subscriber' : 'No subscription',
            price: wishPremium ? 'PriceCHF/insteadCHF' : 'PriceCHF',
            priceValues: wishPremium ? [21, 34] : [34],
            propositions: wishPremium
              ? [
                  'Printed book corona',
                  'Unlimited access to video library',
                  'Access to the entire course offering',
                  'Unlimited access to the forums',
                  'Knowledge reviews',
                  'No advertising breaks',
                ]
              : ['Printed book corona'],
          },
          form: { withPromoCode: false },
          navigation: wishPremium ? '4/4' : '3/3',
          prevStep: 2,
          nextStep: 4,
          shouldSignUp: wishPremium,
          subscribeId: wishPremium ? 5 : null,
          productId: wishPremium ? 1 : 4,
        }),
        [THANKS]: () => ({
          form: {
            title: 'Your order is on its way',
            description:
              'Thank you for your order. The book is on its way to you. Take advantage of the Fintool Premium offer and expand your money knowledge in one of our courses.',
            button: { name: 'To the Fintool Academy', url: '/akademie' },
          },
        }),
      },
    },
    {
      id: 4,
      name: 'In possession of the printed edition',
      tasks: {
        [REGISTER]: () => ({
          banner: {
            title: 'In possession of the printed edition',
            price: 'PriceCHF',
            priceValues: [0],
            propositions: ['3 months Fintool-Premium free'],
          },
          form: {
            showSubscribeDescription: true,
            inputs: [FIRST_NAME, LAST_NAME, ADDRESS, ZIP_CODE, CITY, EMAIL, PASSWORD],
            submitButton: 'Register',
            showAdb: true,
          },
          navigation: '1/2',
          nextStep: 1,
        }),
        [PAYMENT]: () => ({
          banner: {
            title: 'In possession of the printed edition',
            price: 'PriceCHF',
            priceValues: [0],
            propositions: ['3 months Fintool-Premium free'],
          },
          form: { withPromoCode: true },
          navigation: '2/2',
          prevStep: 0,
          nextStep: 2,
          shouldSignUp: true,
          subscribeId: 5,
          productId: null,
        }),
        [THANKS]: () => ({
          form: {
            title: 'Start course now',
            description: 'Take advantage of the Fintool Premium offer and expand your money knowledge in one of our courses.',
            button: { name: 'To the Fintool Academy', url: '/akademie' },
          },
        }),
      },
    },
  ],
};

export default coronaCrash;
